


; (function () {
    var
        _$wrapper = null,
        _report_id = null,
        _popup_open = false,
        _mousedown = false,
        _mousedownRow,
        _mousedownRowNumber = 0,

        init = function () {
            _$wrapper = $('.layout-report-format');
            if (_$wrapper.length > 0) {
                _report_id = _$wrapper.find('#hdnReportID').val();
                $('#image-loading').hide();

                setupMouseDragging();
                setupVerticalLine();
                setupMarginsLink();
                setupPageBreakDisabled();
                setupBreakLineInsert();
                setupBreakLineRemove();
                setupBreakLineRemoveAll();
                setupDropdownItemSelected();
                setupBrowserResize();
            }
        },

        setupBrowserResize = function () {
            // Add an event listener for the resize event
            window.addEventListener('resize', function () {
                // Call the setupVerticalLine function when the browser size changes
                setupVerticalLine();
            });
        },
        setupDropdownItemSelected = function () {
            $('.margin-dropdown, .orientation-dropdown, .heading-dropdown, .font-size-dropdown').on('click', '.dropdown-item', function (event) {
                // Remove 'selected' class from all items within the same dropdown
                // Remove 'item-selected' class from all items within the same dropdown
                $(this).parent().siblings().find('.dropdown-item').removeClass('item-selected');

                // Add 'selected' class to the clicked item
                $(this).addClass('item-selected');
                console.log(this);

                // Call your updateFormattingValues function
                updateFormattingValues();
            });
        },
        setupVerticalLine = function () {
            //============================================================================================
            // START SETTING VERTICAL LINE
            //============================================================================================
            var table = document.getElementById("formatting-table");
            var firstRow;
            var pageColumns = $('#hdnPageColumns').val();
            var totalWidth = 0;
            var reportHeadings = document.querySelectorAll('.report-heading');

            if (table && table.tBodies && table.tBodies[0] && table.tBodies[0].rows.length > 1) {
                // Iterate through the rows to find the first row with data-line-type="Detail"
                for (var i = 0; i < table.tBodies[0].rows.length; i++) {
                    if (table.tBodies[0].rows[i].getAttribute('data-line-type') === 'Detail') {
                        firstRow = table.tBodies[0].rows[i];
                        break; // Stop the loop once the first matching row is found
                    }
                }
            }

            if (firstRow) {
                for (var i = 0; i < parseInt(pageColumns); i++) {
                    // Get the computed width of the cell in pixels
                    var cellWidth = window.getComputedStyle(firstRow.cells[i]).getPropertyValue('width');

                    // Parse the width to remove 'px' and convert it to a number
                    totalWidth += parseFloat(cellWidth);
                }
                document.getElementById('page-vertical-line').style.left = totalWidth + 'px';
                reportHeadings.forEach(function (heading) {
                    heading.style.width = totalWidth - 20 + 'px';
                });

            }


            //============================================================================================
            // END SETTING VERTICAL LINE
            //============================================================================================
        },
        setupMouseDragging = function () {
            //============================================================================================
            // DRAGGING FUNCTIONALITY
            //============================================================================================
            // Set up mouse down and up events for rows in the '#formatting-table' table.
            // When a row is clicked, it checks if it has the 'format-user-page-break' class.
            // If yes, activates 'add-break-line-mode' and initiates dragging functionality.
            // If no, highlights the clicked row and updates the formatting values upon mouse release.
            // Handles logic for selecting, deleting, and updating page break rows.

            var rows = document.querySelectorAll('#formatting-table tr');
            rows.forEach(function (row) {
                row.addEventListener('mousedown', function (event) {
                    // Check if the clicked row has the class 'format-user-page-break'

                    var hasHighlightedClass = row.classList.contains('format-user-page-break');
                    event.preventDefault();

                    if (hasHighlightedClass) {
                        $('#formatting-table tr').addClass('add-break-line-mode');
                        _mousedown = true;
                        if (!_mousedownRow) {
                            _mousedownRow = row;
                            _mousedownRowNumber = row.getAttribute('data-line-index');
                        }

                    } else {
                        $('.format-pre-selected-page-break').removeClass('format-pre-selected-page-break');
                        row.classList.add('format-pre-selected-page-break');
                        console.log('selected');
                        //console.log(row);
                        _mousedown = false;
                    }
                });
            });
            rows.forEach(function (row) {
                row.addEventListener('mouseup', function (event) {
                    if (_mousedown) {
                        _mousedownRow.classList.remove('format-user-page-break');
                        row.classList.add('format-user-page-break');
                        $('#formatting-table tr').removeClass('add-break-line-mode');
                        _mousedown = false;
                        _mousedownRow = null;
                        if (_mousedownRowNumber != row.getAttribute('data-line-index')) {
                            updateFormattingValues();
                        }
                    }
                    if (_mousedownRowNumber === row.getAttribute('data-line-index')) {
                        console.log('selected to be delete');
                        row.classList.add('format-pre-selected-page-break');

                    }
                });
            });

            //============================================================================================
            // END DRAGGING FUNCTIONALITY
            //============================================================================================
        },
        setupMarginsLink = function () {
            _$wrapper.on('click', '.edit-margins', function () {
                if (!_popup_open) {
                    _popup_open = true;
                    delta.ajax.get(
                        '/formatexcel/margins?reportID=' + _report_id,
                        function (result) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Margins',
                                content: result,
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {

                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input').each(function () {
                                        var $elem = $(this);
                                        formData.append($elem.attr('name'), $elem.val());
                                    });

                                    delta.ajax.postFormData(
                                        '/formatexcel/MarginsUpdate',
                                        formData,
                                        function (result2) {
                                            if (result2.isValid) {
                                                //close the popup
                                                delta.popup.close($popup);

                                                var link = '/formatexcel/index?reportID=' + $('#hdnReportID').val();
                                                console.log(link);

                                                window.location = link;
                                            } else {
                                                $popup.find('.modal-body').html(result2.html);
                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );

                                    return false;
                                },
                            });
                        }
                    );
                }
            });
        },
        setupBreakLineInsert = function () {
            _$wrapper.on('click', '.format-break-insert-page-break', function () {
                console.log('add page break');
                $('.format-pre-selected-page-break').addClass('format-user-page-break').removeClass('format-pre-selected-page-break');
                updateFormattingValues();
            })
        },
        setupBreakLineRemove = function () {
            _$wrapper.on('click', '.format-break-remove-page-break', function () {
                console.log('remove page break');
                $('.format-pre-selected-page-break').removeClass('format-user-page-break').removeClass('format-pre-selected-page-break');
                updateFormattingValues();
            })
        },
        setupBreakLineRemoveAll = function () {
            _$wrapper.on('click', '.format-break-reset-all-page-break', function () {
                console.log('remove all page break');
                $('.format-user-page-break').removeClass('format-user-page-break');
                updateFormattingValues();
            })
        },
        setupPageBreakDisabled = function () {
            _$wrapper.on("change", "#PageBreakDisabled", function (e) {
                console.log("Checkbox state changed");
                $('#dropdownPageBreak').dropdown('hide'); // Close the dropdown
                updateFormattingValues(); // Update formatting
            });

            // Prevent dropdown from closing when interacting with the checkbox
            _$wrapper.on("click", "#PageBreakDisabled", function (e) {
                e.stopPropagation();
            });
        },
        updateFormattingValues = function () {
            var formData = new FormData();
            formData.append('ReportID', $('#hdnReportID').val());

            //Margins
            $('.margin-dropdown .item-selected span').each(function () {
                var $elem = $(this);
                formData.append($elem.attr('name'), $elem.data('margin'));
            });

            //Orientation
            var $orientation = $('.orientation-dropdown .item-selected');
            formData.append($orientation.attr('name'), $orientation.data('value'));

            //Heading
            var $heading = $('.heading-dropdown .item-selected');
            formData.append($heading.attr('name'), $heading.data('value'));

            //Font Size
            var $fontSize = $('.font-size-dropdown .item-selected');
            formData.append($fontSize.attr('name'), $fontSize.data('value'));

            // find all 'format-user-page-break' inside the table with id 'formatting-table'
            var rowsWithPageBreakClass = $('#formatting-table .format-user-page-break');

            // find if Page Break is Disabled
            var $pageBreakDisabled = $('#PageBreakDisabled');
            var pageBreakDisabledValue = $pageBreakDisabled.is(':checkbox') ? $pageBreakDisabled.is(':checked') : $pageBreakDisabled.val();
            formData.append($pageBreakDisabled.attr('name'), pageBreakDisabledValue);

            // Iterate through each row and retrieve the data-line-index value
            rowsWithPageBreakClass.each(function () {
                var dataLineIndex = $(this).data('line-index');
                formData.append('PageBreaks', dataLineIndex);
            });

            $('#image-loading').show();
            delta.ajax.postFormData(
                '/formatexcel/Update',
                formData,
                function (result2) {
                    if (result2.isValid) {
                        var link = result2.url;
                        window.location = link;
                    } else {
                        $('#image-loading').hide();
                    }
                }
            );
        },
        dummy = function () { };
    $(document).ready(init);
})();
